import { createAsyncThunk } from '@reduxjs/toolkit';

import { getTermsValue } from '../../../../packages/JsonQuery';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import { updateBSCenters } from 'shared/slices/jsonQuery';
import { ISelectBSCenterParams } from 'shared/types/geoSuggest';
import { IThunkApi } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';

/**
 * Выбор бизнес-центра или торгового центра из гео-саджеста.
 * Оба типа фильтруются по jsonQuery.bs_center (как в legacy-фильтрах).
 */
export const selectBSCenter = createAsyncThunk<void, ISelectBSCenterParams, IThunkApi>(
  'geo/geoSuggest/selectBSCenter',
  async ({ id }, { getState, dispatch }) => {
    const jsonQuery = selectJsonQuery(getState());
    const currentIds: number[] = getTermsValue('bs_center')(jsonQuery) || [];

    if (!currentIds.includes(id)) {
      dispatch(updateBSCenters([...currentIds, id]));
    }

    await dispatch(updateSearchMeta());
  },
);
